import "./App.css"
import Routes from "./routes"
import { Provider } from "react-redux"
import generateStore from "./ducks/store"
import { createTheme, ThemeProvider } from "@material-ui/core/styles"
import { IS_DOODDO } from "./Constantes"
import { useEffect } from "react"
const paletteDooddo = {
  primary: {
    main: "#009bdb",
  },
  secondary: {
    main: "#69a33b",
  },
  warning: {
    main: "#FFFF00"
  }
}
const paletteGranTour = {
  primary: {
    main: "#FF8027",
  },
  secondary: {
    main: "#014C82"
  },
  // text: {
  //   primary: "#014C82",
  //   secondary: "#FFFFFF",
  // },
  warning: {
    main: "#F5A832"
  },
}
const changeFavicon = (faviconURL) => {
  const link = document.querySelector("link[rel*='icon']") || document.createElement("link")
  link.type = "image/x-icon";
  link.rel = "shortcut icon";
  link.href = faviconURL;
  document.head.appendChild(link);
}
const changeTitle = (title) => {
  document.title = title
}
function App() {
  const store = generateStore()
  const theme = createTheme({
    palette: IS_DOODDO ? paletteDooddo : paletteGranTour
  })
  useEffect(() => {
    const faviconURL = IS_DOODDO ? "/favicon.ico" : "/favicon2.ico";
    const title = IS_DOODDO ? "Oficina Dooddo" : "Oficina Grantour"
    changeFavicon(faviconURL)
    changeTitle(title)
  }, [])
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <Routes />
      </ThemeProvider>
    </Provider>
  );
}
export default App;
